import * as React from "react";
import {
  ClickAwayListener,
  ListItemButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./AppSignedUser.scss";
import { display } from "@mui/system";

export default function AppSignedUser({
  userName,
  coName,
  logout,
}) {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const [arrowRef, setArrowRef] = React.useState<HTMLSpanElement | null>(null);
  const open = Boolean(anchorEl);

  const signinBtnRef = React.useRef(null) as any;

  const handleClickAway = () => {
    setAnchorEl(null);
  };

  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));

  const isSignedIn = userName !== "";
  const handleOptionChange = () => {
    logout();
    setAnchorEl(null);
    signinBtnRef.current.focus();
  };
  const navigate = useNavigate();
  const id = open ? "simple-popper" : undefined;

  return (
    <>
      {md && (
        <div className="userSignInMenu" style={{display:"flex",alignItems:"centre"}}>
        <Button
            ref={signinBtnRef}
            variant="text"
            aria-expanded={open}
            aria-label={
              isSignedIn
                ? userName
                : t('appSignedUser.signIn')
            }
            disableRipple
            onClick={(event) => {
              setAnchorEl(anchorEl ? null : event.currentTarget);
              !isSignedIn && navigate(`${i18n.language}/seller-profile`);
            }}
            size="md"
            
            sx={{
              color:"white",
              marginRight: "15px",
              height: "auto",
              width: "fit-content",
              textTransform: "none",
              whiteSpace: "nowrap",
              '&:focus-visible': {
                outline: '2px solid white',
                outlineOffset: '10px',
              },
              '&:hover': {
                color: 'white'
              }
            }}

          >
            {isSignedIn ? userName : t('appSignedUser.signIn')}
            {isSignedIn && <KeyboardArrowDownIcon />}
          </Button>
          {isSignedIn && (
            <Popper
              id={id}
              open={open}
              anchorEl={anchorEl}
              placement="bottom"
              disablePortal={true}
              modifiers={[
                {
                  name: "arrow",
                  enabled: true,
                  options: {
                    element: arrowRef,
                  },
                },
              ]}
              style={{
                zIndex: 999,
              }}
            >
              <ClickAwayListener onClickAway={handleClickAway}>
                <Paper className="userInfo-popper-content" onMouseLeave={handleClickAway}>
                  <List>
                    <ListItem disablePadding>
                      <ListItemButton
                        onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                          navigate(`${i18n.language}/seller-profile`);
                        }}
                        tabIndex={0}
                        onKeyDown={(e) => e.key === "Enter" && navigate(`${i18n.language}/seller-profile`)}
                        className="signMenuBtn"
                        disableRipple
                        role="button"
                      >
                        <ListItemText
                          primary={
                            t('appSignedUser.viewProfile', { coName })
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                    <Divider
                      variant="middle"
                      style={{ padding: "5px" }}
                      aria-hidden="true"
                    />
                    <ListItem disablePadding>
                      <ListItemButton
                        className="signMenuBtn"
                        disableRipple
                        onClick={() => handleOptionChange()}
                        onKeyDown={(event) => {
                          if (event.key === "Tab" && !event.shiftKey) {
                            setAnchorEl(null);
                          } else if (event.key === "Enter") {
                            handleOptionChange()
                          }
                        }}
                      >
                        <ListItemText
                          primary={t('appSignedUser.signOut')}
                        />
                      </ListItemButton>
                    </ListItem>
                  </List>
                  <div className="language-popper-arrow" ref={setArrowRef} />
                </Paper>
              </ClickAwayListener>
            </Popper>
          )}
        </div>
      )}
    </>
  );
}
